import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      background: 'rgba(27, 25, 37, 0.85098)',
      width: '100%',
    },
    container: {
      maxWidth: 532,
      margin: '0 auto',
      padding: '37px 36px',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        padding: '37px 16px',
      },
    },
    title: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 16,
      [theme.breakpoints.up('md')]: {
        fontSize: 26,
        marginBottom: 53,
      },
    },
    text: {
      color: colorsPalette.gray,
      fontSize: 18,
      lineHeight: 1.35,
      textAlign: 'center',
      marginBottom: 24,
      [theme.breakpoints.up('md')]: {
        fontSize: 22,
        marginBottom: 63,
      },
    },
    buttonsWrapper: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    loginBtn: {
      marginRight: 0,
      padding: '19px 45px',
      width: '100%',
      marginTop: SMALL_MARGIN,
      [theme.breakpoints.up('sm')]: {
        marginLeft: 14,
        marginTop: 0,
      },
      [theme.breakpoints.up('md')]: {
        padding: '15px 42px',
      },
    },
    joinBtn: {
      width: '100%',
    },
    closeBtn: {
      cursor: 'pointer',
      position: 'absolute',
      right: 10,
      top: 0,
      width: 20,
      height: 20,
      [theme.breakpoints.up('md')]: {
        right: 0,
      },
    },
  }),
);

export default useStyles;
